export var ChartTypes;
(function (ChartTypes) {
    ChartTypes["bar"] = "bar";
    ChartTypes["line"] = "line";
    ChartTypes["pie"] = "pie";
    ChartTypes["doughnut"] = "doughnut";
    ChartTypes["radar"] = "radar";
})(ChartTypes || (ChartTypes = {}));
